import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import { supabase } from '../lib/supabaseClient';
import { dogs as staticDogs } from '../data/dogs';

function AdoptionPage({ dogId }) {
  const [dog, setDog] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    async function fetchDog() {
      if (!dogId) return;
      
      try {
        const { data, error } = await supabase
          .from('dogs')
          .select('*')
          .eq('id', dogId)
          .single();
          
        if (error) {
          console.error('Error fetching dog from Supabase:', error);
          setDog(staticDogs.find(d => d.id === parseInt(dogId)) || null);
        } else if (data) {
          setDog(data);
        }
      } catch (err) {
        console.error('Error in fetch:', err);
        setDog(staticDogs.find(d => d.id === parseInt(dogId)) || null);
      }
    }

    fetchDog();
  }, [dogId]);

  return (
    <>
      <Navbar />
      <div className="container" style={{ padding: '80px 24px', maxWidth: '800px' }}>
        <button 
          className="btn btn-outline" 
          onClick={() => window.history.back()}
          style={{ marginBottom: '40px' }}
        >
          ← Indietro
        </button>

        <h1 className="section-title" style={{ textAlign: 'left', marginBottom: '16px' }}>
          Questionario Pre-Affido {dog ? `per ${dog.name}` : ''}
        </h1>
        <p className="section-subtitle" style={{ textAlign: 'left', margin: '0 0 48px 0', maxWidth: '100%' }}>
          Compila questo modulo per permetterci di capire se il nostro cane e la tua famiglia siete fatti l'uno per l'altra.
          Le adozioni comportano grandi responsabilità, per questo ti chiediamo di rispondere con la massima sincerità.
        </p>

        <div style={{ background: 'var(--color-bg-primary)', padding: '48px', borderRadius: 'var(--radius-lg)', boxShadow: 'var(--shadow-sm)' }}>
          {dog && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '32px', paddingBottom: '32px', borderBottom: '1px solid #ddd' }}>
              <img src={dog.image} alt={dog.name} style={{ width: '80px', height: '80px', borderRadius: '50%', objectFit: 'cover' }} />
              <div>
                <h3 style={{ margin: 0 }}>Stai inviando una richiesta per {dog.name}</h3>
                <p style={{ margin: 0, color: 'var(--color-text-light)' }}>Età: {dog.age} | Taglia: {dog.size}</p>
              </div>
            </div>
          )}

          <form onSubmit={(e) => { e.preventDefault(); alert("Questionario inviato con successo! Valuteremo la tua richiesta e ti contatteremo presto."); window.location.hash = ''; }}>
            {/* Dati Personali */}
            <h4 style={{ marginBottom: '20px', color: 'var(--color-primary-dark)' }}>I tuoi dati</h4>
            
            <div className="form-group" style={{ display: 'flex', gap: '20px' }}>
              <div style={{ flex: 1 }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Nome e Cognome *</label>
                <input type="text" required placeholder="Es. Lucia Bianchi" />
              </div>
              <div style={{ flex: 1 }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Età *</label>
                <input type="number" required placeholder="Es. 32" min="18" />
              </div>
            </div>

            <div className="form-group" style={{ display: 'flex', gap: '20px' }}>
              <div style={{ flex: 1 }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Città di Residenza *</label>
                <input type="text" required placeholder="Dove andrà a vivere il cane?" />
              </div>
              <div style={{ flex: 1 }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Telefono *</label>
                <input type="tel" required placeholder="Il tuo numero" />
              </div>
            </div>

            {/* Ambiente e Famiglia */}
            <h4 style={{ margin: '40px 0 20px 0', color: 'var(--color-primary-dark)' }}>Ambiente Domiciliare</h4>

            <div className="form-group">
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Tipologia di abitazione *</label>
              <select style={{ width: '100%', padding: '16px', border: '1px solid #ddd', borderRadius: '12px', fontFamily: 'var(--font-secondary)' }} required>
                <option value="">Seleziona...</option>
                <option value="appartamento_senza_balcone">Appartamento senza balcone</option>
                <option value="appartamento_balcone">Appartamento con balcone</option>
                <option value="casa_giardino">Casa con giardino recintato</option>
                <option value="campagna">Casa di campagna</option>
              </select>
            </div>

            <div className="form-group">
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Ci sono bambini in casa? *</label>
              <div style={{ display: 'flex', gap: '20px', padding: '8px 0' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                  <input type="radio" name="bambini" value="si" required /> Si
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                  <input type="radio" name="bambini" value="no" /> No
                </label>
              </div>
            </div>

            <div className="form-group">
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Hai altri animali in casa (cani/gatti)? *</label>
              <textarea placeholder="Se sì, specificare sesso, età e carattere..." style={{ minHeight: '80px' }} required></textarea>
            </div>

            <div className="form-group">
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Hai già esperienza nella gestione di cani? *</label>
              <select style={{ width: '100%', padding: '16px', border: '1px solid #ddd', borderRadius: '12px', fontFamily: 'var(--font-secondary)' }} required>
                <option value="">Seleziona la tua esperienza...</option>
                <option value="alta">Sì, ho molta esperienza (ho avuto/lavorato con cani problematici o di varie taglie)</option>
                <option value="media">Sì, ho sempre avuto cani in famiglia fin da piccolo</option>
                <option value="bassa">Ho avuto solo esperienze brevi o con cani molto tranquilli</option>
                <option value="nessuna">Nessuna esperienza, sarebbe il mio primo cane in assoluto</option>
              </select>
            </div>

            <div className="form-group">
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Quante ore il cane resterà da solo in casa? *</label>
              <input type="number" required placeholder="Es. 4" min="0" max="24" />
            </div>

            <button type="submit" className="btn btn-primary" style={{ width: '100%', padding: '16px', fontSize: '18px', marginTop: '24px' }}>
              Invia Questionario
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default AdoptionPage;
